export default "__VITE_ASSET__npgTDu$cVqgJQrMI91c9kQ__"